import { createContext } from 'react';

import { createStore, Store } from '../../../core/store/store.js';
import { initialState } from '../constants/defaults.js';
import type { XYChartState } from '../types/state.js';

export const XYChartStoreContext = createContext<Store<XYChartState>>(
  createStore<XYChartState>(initialState),
);

XYChartStoreContext['displayName'] = 'XYChartStoreContext';
